import { getEndpoint } from "@api-routes/endpoint";
import { getProspectReference } from "@utils/storage";
import { keycloakUtils } from "itsf-ui-common";

const MS_NAME = "eir-stancer-facade";

export const getIframeAndValidatePaymentAcquisitionApiRoute = () =>
    `${getEndpoint(MS_NAME)}hpp/acquisition-prospects/${getProspectReference()}`;

export const getIframeAndValidatePaymentCrossSellApiRoute = () =>
    `${getEndpoint(MS_NAME)}hpp/cross-sells/${getProspectReference()}`;

export const getIframeAndValidatePaymentApiRoute = () =>
    keycloakUtils.isAuthenticated()
        ? getIframeAndValidatePaymentCrossSellApiRoute()
        : getIframeAndValidatePaymentAcquisitionApiRoute();

export const payWithSavedCardAcquisitionApiRoute = (cardId: string) =>
    `${getEndpoint(MS_NAME)}acquisition-prospects/${getProspectReference()}/cards/${cardId}`;

export const payWithSavedCardCrossSellApiRoute = (cardId: string) =>
    `${getEndpoint(MS_NAME)}cross-sells/${getProspectReference()}/cards/${cardId}`;

export const payWithSavedCardApiRoute = (cardId: string) =>
    keycloakUtils.isAuthenticated()
        ? payWithSavedCardCrossSellApiRoute(cardId)
        : payWithSavedCardAcquisitionApiRoute(cardId);

export const getPaymentMethodListApiRoute = () => `${getEndpoint(MS_NAME)}payments/methods`;
